"use client";
import cn from "classnames";
import { type ComponentPropsWithoutRef, type ReactNode } from "react";
import Layout from "@/components/common/Layout";
import { useScrollVisibility } from "@/hooks/useScrollVisibility";
import s from "./NavHeader.module.scss";

export interface NavHeaderProps extends ComponentPropsWithoutRef<"header"> {
  desktopHeader: ReactNode;
  desktopLogo: ReactNode;
  mobileHeader: ReactNode;
  fullWidth?: boolean;
}

export default function NavHeader(props: NavHeaderProps) {
  const { desktopHeader, desktopLogo, mobileHeader, fullWidth, ...restProps } =
    props;
  const { isVisible } = useScrollVisibility();

  const headerClassName = cn(
    s.header,
    restProps.className,
    isVisible ? s.visible : s.hidden,
  );

  return (
    <header {...restProps} className={headerClassName}>
      <div className={s.desktopHeader}>
        <Layout fluid={fullWidth} containerOnly>
          <div className={s.desktopWrapper}>
            <div className={s.desktopLogo}>{desktopLogo}</div>
            <div className={s.desktopMenu}>{desktopHeader}</div>
          </div>
        </Layout>
      </div>
      <div className={s.mobileHeader}>{mobileHeader}</div>
    </header>
  );
}
